// extracted by mini-css-extract-plugin
module.exports = {"colors":"'../../variables.css'","textAreaQuestion":"_3Ks12rWLPI2TvCaKz5uizq","counter":"_1Y4vdabqqCEvZuKAVCxY4c"};